import { render, staticRenderFns } from "./BackToEntryPageButton.vue?vue&type=template&id=f92f1268"
import script from "./BackToEntryPageButton.vue?vue&type=script&lang=js"
export * from "./BackToEntryPageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports